import { InfoIcon } from '@chakra-ui/icons'
import { Box, Collapse, Flex, Text } from '@chakra-ui/react'
import { ScreenContext } from '@hb/react'
import { useContext } from 'react'
import { ActionButton, SolidActionButton } from '../../Buttons/ActionButton'

export const ShouldNotify = ({
  shouldNotify,
  setShouldNotify,
  message,
}: {
  shouldNotify: boolean | null
  setShouldNotify: (shouldNotify: boolean) => void
  message?: string
}) => {
  const { isMobile } = useContext(ScreenContext)
  return (
    <Collapse style={{ width: '100%' }} in={shouldNotify === null}>
      <Flex flexFlow="column" w="100%">
        {message ? (
          <Flex
            gap={1.5}
            px={3}
            py={1}
            w="100%"
            borderBottom="1px solid"
            borderColor="gray.200"
            align="center">
            <Box>
              <InfoIcon color="gray.500" mr={1} position="relative" />
            </Box>
            <Text flex={1} minW="0" color="gray.600" fontWeight={400}>
              {message}
            </Text>
          </Flex>
        ) : null}
        <Flex flexFlow={isMobile ? 'column' : 'row'} gap={1.5} w="100%" px={3} py={2}>
          <SolidActionButton size="sm" flex={1} onClick={() => setShouldNotify(true)}>
            Notify HB Admins
          </SolidActionButton>
          <ActionButton size="sm" flex={1} onClick={() => setShouldNotify(false)}>
            Do not notify
          </ActionButton>
        </Flex>
      </Flex>
    </Collapse>
  )
}
